import Axios from "./axios";

const resource = "data-privacies";
const resellerResource = "reseller-data-privacies";

export default {
  get() {
		return Axios.get(`${resource}`);
	},
	resellerGet(params) {
		return Axios.get(`${resellerResource}`, params);
	}
}